import axios from '../axios';

export default {
  process(rootName) {
    return {
      list() {
        return axios.get(`/${rootName}.json`);
      },
      get(id) {
        return axios.get(`/${rootName}/${id}.json`);
      },
    };
  },
};
